import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu"]

    toggle() {
        this.menuTarget.classList.toggle("hidden")
        this.syncExpanded()
    }

    close() {
        if (this.menuTarget.classList.contains("hidden")) return
        this.menuTarget.classList.add("hidden")
        this.syncExpanded()
    }

    syncExpanded() {
        const toggler = this.element.querySelector("[aria-expanded]")
        if (toggler) {
            toggler.setAttribute("aria-expanded", String(!this.menuTarget.classList.contains("hidden")))
        }
    }

    select(event) {
        const select = this.element.querySelector("select")
        select.value = event.currentTarget.dataset.value
        select.dispatchEvent(new Event("change"))
        this.close()
    }

    // Optional: Close dropdown when clicking outside
    clickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    handleKeydown(event) {
        if (event.key === "Escape") {
            this.close()
        }
    }

    connect() {
        this.boundClickOutside = this.clickOutside.bind(this);
        this.boundHandleKeydown = this.handleKeydown.bind(this);
        document.addEventListener("click", this.boundClickOutside);
        document.addEventListener("keydown", this.boundHandleKeydown);
    }

    disconnect() {
        document.removeEventListener("click", this.boundClickOutside);
        document.removeEventListener("keydown", this.boundHandleKeydown);
    }
}
